const ProductName = {
  Personal: 'Personal cover',
  Vehicle: 'Vehicle cover',
  Hybrid: 'Hybrid cover',

};
export default ProductName;
